export var MARKUP_TYPES = {
  MARKUP_BASED: 'MARKUP',
  FLAT_AMOUNT: 'FLAT_AMOUNT',
  CAPCOST_BASED: 'CAPCOST_PCT'
};